import RcSelect from "rc-select";
import { withProps } from "../helpers/reactHelpers";
import "./selectItem.scss";

// Change default props
export const SelectItem = withProps(RcSelect, {
  optionLabelProp: "children",
  optionFilterProp: "children",
});

export { Option, OptGroup } from "rc-select";

/**
 * Convert a three-state boolean value into something that can be used with SelectItem.
 * Use with tristateToBoolean.
 */
export const tristateToSelectValue = (value: boolean | null): number => {
  if (value === true) {
    return 2;
  }
  else if (value === false) {
    return 1;
  }
  else {
    return 0;
  }
};

/**
 * Convert the representation of a three-state boolean in SelectItem back into a boolean | null.
 * Use with tristateToSelectValue.
 */
export const tristateToBoolean = (option: number): boolean | null => {
  switch (option) {
    case 1: return false;
    case 2: return true;
    default: return null;
  }
};

